module.exports = __webpack_public_path__ + "img/hqms.2b138842.jpg";